import { useAdsAnaliticsStore } from "src/store/ads-analitics.store";
import styles from "./styles.module.scss";
import { CampaignsTable } from "@pages/AdsAnalitics/components/Campaigns/components/Tables/CampaignTable";

const Optimization = () => {
  const { isWhatIfEnabled } = useAdsAnaliticsStore((state) => ({
    isWhatIfEnabled: state.isWhatIfEnabled,
    compareWith: state.compareWith,
  }));

  return (
    <div className={styles.optimizationWrapper}>
      <CampaignsTable isWhatIf={isWhatIfEnabled} />
    </div>
  );
};

export default Optimization;
